$(document).ready(function () {
    $('.slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
    });
});


$(document).ready(function(){
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        arrows: true,
        centerMode: true,
        focusOnSelect: true,
    });
});


$('.slider-steps').slick({
    slidesToShow  : 3,
    slidesToScroll: 1,
    variableWidth : true,
    adaptiveHeight: false,
    arrows        : true,
    dots          : false,
    infinite      : false,
});